import * as React from "react";
import { Box, Text, useLocalVariant } from "@draftkings/arena-web";
export const BetReturns = React.memo(function BetReturns(props) {
    const { purchaseId, formattedStake, formattedReturns, onClick } = props;
    const betStake = useLocalVariant("text", {
        $extendFromVariant: "betText",
        root: {
            marginRight: "$s1",
        }
    });
    const clickableAreaStyles = typeof onClick === "function" ? {
        cursor: "pointer",
    } : {};
    return React.createElement("div", { "data-testid": `bet-returns-clickable-area-${purchaseId}`, "data-test-id": `bet-returns-clickable-area-${purchaseId}`, onClick: onClick, style: clickableAreaStyles },
        React.createElement(Box, { marginBottom: "$s2", height: "20px" },
            React.createElement(Text, { testId: `bet-stake-${purchaseId}`, variant: betStake, as: "span" }, formattedStake),
            formattedReturns && React.createElement(Text, { testId: `bet-returns-${purchaseId}`, variant: "betText", as: "span" }, formattedReturns)));
});
//# sourceMappingURL=BetReturns.js.map